import React from 'react';
import styled from 'styled-components/macro';
import {
  Heading1, Heading3, LinkStyled, Paragraph,
} from '../../components/typography';
import {
  Container, Row, Col, Div,
} from '../../components/grid';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ReadMore from '../../components/ReadMore';
import { Price } from '../../containers/commerce';

const DivStyledLeft = styled(Div)`
  margin: -15px -7.5px -15px -15px;
  background: #fff;
  padding: 15px;
  height: 100%;

  @media (max-width: 767px) {
    margin: -15px -15px 0px -15px;
  }
`;

const DivStyledRight = styled(Div)`
  margin: -15px -15px -15px -7.5px;
  background: #fff;
  padding: 15px;
  height: 100%;

  @media (max-width: 767px) {
    margin: 0px -15px -15px -15px;
  }
`;

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="LeveringAfhentning">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Levering og/eller afhentning</Heading1>
          <Paragraph>
            Der findes 4 muligheder for levering og/eller afhentning.
          </Paragraph>
          <Paragraph>
            Du kan finde <LinkStyled to="/levering-afhentning/levering/fadoel">uddybende information om levering og afhentning af fadøl</LinkStyled>
          </Paragraph>
          <Paragraph>
            Læs om fordelene ved at vælge os som jeres <LinkStyled to="/leverandoer-sodavand-kildevand-oel">leverandør af sodavand, kildevand og øl</LinkStyled>.
          </Paragraph>
          <Paragraph>
            Du kan også læse mere om <LinkStyled to="/levering-afhentning/afhentning">vejledning til afhentning</LinkStyled>.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <Row>
        <Col xs={12} md={6}>
          <DivStyledLeft>
            <Heading3 marginBottom="0">
              Henter selv - Gratis
            </Heading3>
            <Paragraph>med returret på ubrudte fustager</Paragraph>
            <Paragraph>Du kan hente dine varer gratis på vores lager Park Allé 352A, 2605 Brøndby. Lageret har åbent alle hverdage 7:00 til 16:00.</Paragraph>
            <Paragraph>
              Ekspedition aften og weekend muligt, pris fra <Price varenr="650" momsIndication />. Læg dine varer i kurven, gå til kassen og vælg dag og tidspunkt - ekspeditionsprisen vil fremgå.
            </Paragraph>
            <ReadMore>
              <Paragraph fontSize="14px">
                Du kan betale online på forhånd eller med betalingskort på lageret når du afhenter.
                Ekspeditionen går hurtigst hvis du har betalt på forhånd.
              </Paragraph>
              <Paragraph fontSize="14px">
                Online betaling hæves først efter modregning af evt. pant og/eller efter aflevering af lejet fadølsanlæg.
                Der hæves kun det faktiske forbrug.
              </Paragraph>
              <Paragraph fontSize="14px">
                Returnerer du senere tomme og/eller ubrudte fustager, tilbagebetaler vi pant samt vareprisen, på nær <Price varenr="641" /> pr. fustage.
                Returbeløbet tilbageføres direkte til dit betalingskort. Fyldte fustager skal returneres inden 14 dage. Tomme fustager kan du beholde så længe du vil.
              </Paragraph>
              <Paragraph fontSize="14px">
                Spørgsmål til bestilling ring 43 27 00 00.
              </Paragraph>
            </ReadMore>
          </DivStyledLeft>
        </Col>
        <Col xs={12} md={6}>
          <DivStyledRight>
            <Heading3 marginBottom="0">
              Levering &amp; afhentning - <Price varenr="621" />
            </Heading3>
            <Paragraph>med returret på ubrudte fustager</Paragraph>
            <Paragraph>
              Vi levererer og opsætter dit udstyr og afhenter efterfølgende ubrudte fustager,
              fadølsanlæg og andet udstyr fra begivenheden.
            </Paragraph>
            <Paragraph>
              Gælder i storkøbenhavn og omegn.
            </Paragraph>
            <Paragraph fontSize="12px">
              Leveringsprisen forhøjes uden for normal arbejdstid, samt i julesæsonen.
            </Paragraph>
            <ReadMore>
              <Paragraph fontSize="14px">
                Vores chauffør bærer udstyr og andre varer helt ind hvor du ønsker det og tester at alt virker inden han går igen.
                Øl og anlæg kan sagtens tilsluttes 1 - 2 dage før brug, uden at smagen forringes eller øllet bliver dårligt/fladt.
              </Paragraph>
              <Paragraph fontSize="14px">
                Online betaling hæves først efter afhentning og kun for det faktiske forbrug.
                Ubrugte fustager refunderes til fuld pris på nær <Price varenr="641" /> pr. fustage.
              </Paragraph>
            </ReadMore>
          </DivStyledRight>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <Row>
        <Col xs={12} md={6}>
          <DivStyledLeft>
            <Heading3 marginBottom="0">
              Levering
            </Heading3>
            <Paragraph>
              Ingen returret på ubrudte fustager.<br />
              Vi tager gerne dit returpant i forbindelse med levering.
            </Paragraph>
            <Paragraph>
              Mulighed for gratis levering.<br />
              Normalt efter 1-2 hverdage, eller vælg dato i kassen.
            </Paragraph>
            <Paragraph fontSize="14px">
              Gratis levering ved bestilling af mindst 120-150 dåser/flasker, mindst 50 liter fadøl eller 2 kulsyreflasker.
            </Paragraph>
            <Paragraph fontSize="14px">
              Gratis levering gælder ikke fadølsanlæg og bar samt andet lejet udstyr.
            </Paragraph>
            <ReadMore>
              <Paragraph fontSize="14px">
                Pant i form af kasser med/uden flasker, kulsyreflasker og fustager modtages gerne i forbindelse med leveringen. Ingen returret på fyldte fustager eller andre fyldte varer.
                Ved efterfølgende aflevering af returemballage udbetales pant.
              </Paragraph>
              <Paragraph fontSize="14px">
                Mindre ordre mod transport tillæg, læg varer i kurven og se transport omkostningerne.
                Spørgsmål til bestilling ring 43 27 00 00
              </Paragraph>
            </ReadMore>
          </DivStyledLeft>
        </Col>
        <Col xs={12} md={6}>
          <DivStyledRight>
            <Heading3 marginBottom="0">
              Levering med Post Nord - <Price varenr="620" />
            </Heading3>
            <Paragraph>
              Denne leveringsform gælder kun ved køb af reservedele.
            </Paragraph>
            <Paragraph>
              Kan ikke kombineres med andre varetyper.
            </Paragraph>
            <Paragraph>
              Leveringstiden er ca. 1 - 3 hverdage.
            </Paragraph>
          </DivStyledRight>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
